import ComparisonTable from '../questions/complexQuestions/ComparisonTable';
import FieldArrayTable from '../questions/complexQuestions/fieldArrayTable/FieldArrayTable';
import FieldArrayLayout from '../questions/complexQuestions/fieldArrays/fieldArrayLayout/FieldArrayLayout';
import Autofill from './../questions/complexQuestions/Autofill';
import QuestionLibraryFormGrid from './../questions/complexQuestions/FormGrid';

type ComplexQuestionMapperProps = {
  question?: any;
  isParentShowing?: boolean;
};

/**
 * @typedef {object} ComplexQuestionMapperProps
 * @property {import('../types/complexQuestion').ComplexQuestion} question
 *
 * @param {ComplexQuestionMapperProps} props - The props for the component.
 * @returns
 */
export default function ComplexQuestionMapper({
  question,
  isParentShowing = true,
}: ComplexQuestionMapperProps) {
  const { type } = question;

  const complexQuestionMapper = {
    comparisonTable: (
      <ComparisonTable question={question} isParentShowing={isParentShowing} />
    ),
    fieldArrayTable: <FieldArrayTable question={question} />,
    fieldArrayLayout: (
      <FieldArrayLayout question={question} isParentShowing={isParentShowing} />
    ),
    formGrid: (
      <QuestionLibraryFormGrid
        question={question}
        isParentShowing={isParentShowing}
      />
    ),
    autofill: <Autofill question={question} />,
  };

  return (
    complexQuestionMapper[type] ?? (
      <p>
        No Complex Question with type of <strong>{type}</strong>
      </p>
    )
  );
}
